



























































































































































































































import { Census, Department, Expense } from "@/api";
import { TableRow as ExpenseTableRow } from "@/common/ExpenseTableRow";
import { addDayOnDate, dateFormat } from "@/common/date_format";
import _ from "lodash";
import moment from "moment";
import { Vue, Component } from "vue-property-decorator";
import ExpenseForm from "../ExpenseForm.vue";
import CategoryReportMobile from "./CategoryReportMobile.vue";
import { formatCurrency } from "@/tool/formatCurrency";
import { calculateActualPPD } from "@/tool/budgetUtils";

@Component({
  components: {
    ExpenseForm,
    CategoryReportMobile,
  },
})
export default class CategoryReport extends Vue {
  date =
    (this.$route.query.date as string) ||
    new Date().toISOString().substring(0, 7);
  days = moment()
    .endOf("month")
    .format("DD");
  formattedDate = moment(this.date).format("MMMM");
  menu = false;
  departmentId = parseInt(this.$route.params?.departmentId) || 0;
  categoryId = parseInt(this.$route.params?.categoryId) || 0;
  popDialog = false;
  loadingData = false;
  key = 0;
  totalRemaining = 0;
  totalSpent = 0;
  actualPPD = 0;
  dateFormat = dateFormat;
  maxDate = new Date().toISOString().substring(0, 7);
  selected = [];
  formatCurrency = formatCurrency;
  editData: ExpenseTableRow | null = null;
  headers = [
    {
      text: "Number",
      value: "index",
      sortable: false,
    },
    {
      text: "Order Date",
      value: "orderDate",
      sortable: false,
      align: "center",
    },
    { text: "Vendor", value: "vendor", sortable: false },
    { text: "Description", value: "description", sortable: false },
    { text: "Amount", value: "amount", sortable: false, align: "center" },
    { text: "Balance", value: "balance", sortable: false, align: "center" },
    {
      text: "Date Received",
      value: "dateReceived",
      sortable: false,
      align: "center",
    },
    { text: "Invoice", value: "invoice", sortable: false, align: "center" },
    {
      text: "AP Verified",
      value: "apVerified",
      sortable: false,
      align: "center",
    },
  ];

  created() {
    this.getDepartmentCategories(true);
    this.fetchExpenses();
  }

  get departments() {
    return this.$store.getters["categoryBudget/departments"]?.map(
      (department: Department) => {
        return {
          ...department,
          header: undefined,
        };
      },
    );
  }

  async getDepartmentCategories(isCreated = false) {
    if (!isCreated) {
      this.categoryId = 0;
    }
    await this.$store.dispatch("departmentAdmin/getCategories", {
      departmentId: this.departmentId,
    });
    this.fetchExpenses();
  }

  get categories() {
    const categoryList =
      this.$store.getters["departmentAdmin/categories"] || [];
    const orderCategories = _.orderBy(categoryList, ["category"], ["asc"]);
    return orderCategories;
  }

  get fetchUpdate() {
    const res = this.$store.getters["categoryBudget/fetchExpenses"];

    const isCurrentMonth = moment(this.date, "YYYY-MM").isSame(
      moment(),
      "month",
    );

    if (isCurrentMonth) this.fetchExpenses();
    return res;
  }

  formatDate() {
    this.formattedDate = moment(this.date).format("MMMM");
  }

  get budget() {
    const catBudget = this.$store.getters["categoryBudget/categoryBudget"];
    return catBudget;
  }

  get census() {
    const companyCensus = this.$store.getters[
      "categoryBudget/census"
    ] as Census;
    const census = companyCensus?.census || 0;
    return census;
  }

  get expenses() {
    const depExpenses =
      this.$store.getters["categoryBudget/departmentExpenses"] || [];

    this.totalSpent = 0;
    let budget = this.budget?.budget || 0;
    const tableRows: ExpenseTableRow[] = [];
    let index = 0;
    let mtdSpend = 0;

    depExpenses.map((expense: Expense) => {
      index++;
      const balance = (budget - expense.amount).toFixed(2);
      budget = balance;
      mtdSpend += expense.amount;
      tableRows.push({
        id: expense.id,
        index,
        catId: expense.catId,
        orderDate: expense.orderDate,
        vendor: expense.vendor,
        description: expense.description || "N/A",
        amount: expense.amount.toFixed(2),
        balance: budget,
        dateReceived: expense.receivedAt
          ? dateFormat(expense.receivedAt)
          : "Pending",
        invoice: expense.invoice,
        apVerified: expense.apVerified || 0,
        receipt: expense.receipt,
      });
    });
    this.totalRemaining =
      tableRows[tableRows.length - 1]?.balance || this.budget?.budget || 0;
    this.totalSpent = mtdSpend;
    this.actualPPD = calculateActualPPD(mtdSpend, this.census, this.date) || 0;
    return tableRows;
  }

  async fetchExpenses() {
    const [year, month] = this.date.split("-");
    const date = moment({
      year: parseInt(year),
      month: parseInt(month) - 1,
      day: 1,
    });
    const beginAt = date.format("YYYY-MM-DD");
    const endAt = addDayOnDate(date.endOf("month").format("YYYY-MM-DD"));
    [, , this.days] = endAt.split("-");
    this.loadingData = true;
    const census = this.$store.dispatch("categoryBudget/getCensus", {
      beginAt,
      endAt,
    });
    const departments = this.$store.dispatch("categoryBudget/getDepartments", {
      beginAt,
      endAt,
    });
    const budget = this.$store.dispatch("categoryBudget/getCategoryBudget", {
      departmentId: this.departmentId,
      categoryId: this.categoryId ? this.categoryId : undefined,
      beginAt,
      endAt,
    });
    const expenses = this.$store.dispatch(
      "categoryBudget/getDepartmentExpenses",
      {
        departmentId: this.departmentId,
        categoryId: this.categoryId ? this.categoryId : undefined,
        beginAt,
        endAt,
      },
    );
    await Promise.all([budget, expenses, census, departments]);
    this.loadingData = false;
  }

  clearFilter() {
    this.date = new Date().toISOString().substring(0, 7);
    this.days = moment()
      .endOf("month")
      .format("DD");
    this.departmentId = parseInt(this.$route.params?.departmentId) || 0;
    this.categoryId = parseInt(this.$route.params?.categoryId) || 0;
    this.fetchExpenses();
  }

  editExpenses(item: ExpenseTableRow) {
    this.key++;
    this.editData = item;
    this.popDialog = true;
  }

  addExpense() {
    this.key++;
    this.editData = null;
    this.popDialog = true;
  }

  backToList() {
    this.$router.push({
      path: "/expense-report/owner",
    });
  }

  filterExpense({
    departmentId,
    categoryId,
    date,
  }: {
    departmentId: number;
    categoryId: number;
    date: string;
  }) {
    this.date = date;
    this.departmentId = departmentId;
    this.categoryId = categoryId;
    this.fetchExpenses();
  }
}
